import _ from 'lodash';
import HelperObject from 'utils/helper-object';
import { createDateHelper, dateFormat } from 'utils/date-helper';

// Explicit booking date formats do not need a server clock or store.
const bookingDates = createDateHelper();

export const prepareBookingsForRedux = ( bookings ) => {
	const data = {};

	_.forEach( HelperObject.groupByGuid( bookings ), ( value, key ) => {
		const bookingDate = _.get( value, 'booking_date', '' );
		const bookingDateDayjs = bookingDates.date( bookingDate, dateFormat.DATE );

		data[ key ] = {
			...value,
			dayjs: bookingDateDayjs,
			year: bookingDateDayjs.format('YYYY'),
			month: bookingDateDayjs.format('MM'),
			week: bookingDateDayjs.format('WW'),
			day: bookingDateDayjs.format('DD'),
		};
	});

	return data;
}
;
